import React from 'react'
import slugify from 'slugify'

import transformLink from '~/utils/transformLink'

import ButtonArrow from '~/components/core/buttonArrow'
import Image from '~/components/core/Image'
import Wysiwyg from '~/components/core/Wysiwyg/Wysiwyg'

const ImageText = ({ data }) => {
  const theme = data.theme ? slugify(data.theme).toLowerCase() : 'purple'
  const content = data.content
  const cta = data.cta ? (data.cta.fields ? data.cta.fields : data.cta) : null
  let contentTypeContentful, url

  let proportions = data.proportions ? data.proportions : null
  let classesText = 'md-col-6 lg-col-4 xl-col-3'
  let classesImg = 'md-col-6 lg-col-3 xl-col-4'
  let width = 640

  if (proportions) {
    proportions = proportions === 'Image plus grande' ? 'bigImg' : 'bigTxt'

    if (proportions === 'bigImg') {
      classesText = 'md-col-6 lg-col-4 xl-col-2'
      classesImg = 'md-col-6 lg-col-3 xl-col-5'
      width = 800
    } else {
      classesText = 'md-col-6 lg-col-4 xl-col-5'
      classesImg = 'md-col-6 lg-col-3 xl-col-2'
      width = 320
    }
  }

  if (cta) {
    let ctaContent = transformLink(cta, true, false)
    contentTypeContentful = ctaContent.contentTypeContentful
    url = ctaContent.url
  }

  return (
    <div className={`row slice-bg slice-bg--${theme}`}>
      <div className="col-12 lg-col-9 xl-col-8 lg-col-offset-1">
        <div className="img-text-slice">
          <div className="row">
            {/* text */}
            <div
              className={`col-12 ${classesText} self-center ${data.reversed ? 'lg-col-offset-1 md:order-1' : ''}`}
            >
              <div
                className={`${data.reversed ? 'md:pl-8' : 'md:pr-8'} lg:p-0`}
              >
                <h2
                  className={`title-block ${theme === 'light-blue' ? 'text-blue' : 'text-white'}`}
                >
                  {data.title}
                </h2>

                <Wysiwyg
                  document={content}
                  classes={`${cta ? 'mb-8' : ''} ${theme === 'blue' ? 'paragraph--purple-list' : ''}`}
                />

                {cta && (
                  <ButtonArrow
                    text={cta.label}
                    link={url}
                    contentType={contentTypeContentful}
                    color={theme === 'purple' ? 'blue' : 'purple'}
                  />
                )}
              </div>
            </div>

            {/* image */}
            <div
              className={`col-12 ${classesImg} ${data.reversed ? '' : 'lg-col-offset-1'} mt-11 md:mt-0`}
            >
              {data.image && (
                <Image
                  classes="w-full"
                  width={width}
                  maxWidth={true}
                  sizes={{ 415: [354], 767: [707], 1023: [481] }}
                  image={data.image}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ImageText
